import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {baseUrl} from "../../../../constants/base-url";
import {AttachDetachBloggersByGroup, BloggerGroupsData, CreateBloggerGroupParams} from "../types/blogger-groups.types";
import {bloggerGroupsResourceType} from "../configs/blogger-groups-config";

@Injectable({
  providedIn: 'root'
})
export class BloggerGroupsApiService {
  private http = inject(HttpClient);

  public createBloggerGroup(createBloggerGroupParams: CreateBloggerGroupParams): Observable<BloggerGroupsData> {
    return this.http.post<BloggerGroupsData>(`${baseUrl}/${bloggerGroupsResourceType.path}`, createBloggerGroupParams)
  }

  public attachBloggersByGroup({ id, bloggerIds }: AttachDetachBloggersByGroup): Observable<void> {
    return this.http.post<void>(`${baseUrl}/${bloggerGroupsResourceType.path}/attach/${id}`, {}, {
      params: { bloggerIds: bloggerIds }
    });
  }

  public detachBloggersByGroup({ id, bloggerIds }: AttachDetachBloggersByGroup): Observable<void> {
    return this.http.post<void>(`${baseUrl}/${bloggerGroupsResourceType.path}/detach/${id}`, {}, {
      params: { bloggerIds: bloggerIds }
    });
  }

  public deleteBloggerGroup(id: number): Observable<void> {
    return this.http.delete<void>(`${baseUrl}/${bloggerGroupsResourceType.path}/${id}`);
  }
}
